import React from 'react';
import styled from 'styled-components';

interface TotalProgressBarProps {
  percentage: number;
  total: string;
  burned: string;
}

const Container = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 20px 0;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 15px;
  }
`;

const Label = styled.div<{ right?: boolean }>`
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  display: flex;
  justify-content: ${({ right }) => (right ? 'flex-end' : 'space-between')};
  margin-bottom: ${({ right }) => (right ? '0' : '10px')};
  width: 100%;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 6px;
  }
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 30px;
  background-color: #1a202c;
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid #00f9a9;
  margin: 10px 0;

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    height: 25px;
  }
`;

const Progress = styled.div<{ percentage: number }>`
  width: ${({ percentage }) => percentage}%;
  height: 100%;
  background: linear-gradient(90deg, #00f9a9, #00f9a9);
  transition: width 0.5s ease;
`;

const TotalProgressBar: React.FC<TotalProgressBarProps> = ({ percentage, total, burned }) => {
  return (
    <Container>
      <Label>
        <span>Total Goal: {total.toLocaleString()}</span>
      </Label>
      <ProgressBarContainer>
        <Progress percentage={percentage} />
      </ProgressBarContainer>
      <Label right>
        <span>
          {burned.toLocaleString()} / {total.toLocaleString()}
        </span>
      </Label>
    </Container>
  );
};

export default TotalProgressBar;
